import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';

@Injectable()
export class ActivityService {
  // private http: Http,
  constructor(private authHttp: AuthHttp) { }

  getActivities(year:number) {
    return this.authHttp.get("/api/activity/foryear/"+year).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  getActivity(id: number) {
    return this.authHttp.get("/api/activity/" + id).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  getActivityKinds() {
    return this.authHttp.get("/api/activity/kinds").map(res => res.json());
  }

  create(activity: any) {
    return this.authHttp.post('/api/activity/', activity).map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete('/api/activity/' + id).map(res => res.json());
  }

  update(activityId: number, activity: any) {
    return this.authHttp.put('/api/activity/' + activityId, activity).map(res => {
      return { 'status': res.status, 'value': res.json() }
    })
  }

  getYears(){
    return this.authHttp.get('/api/activity/yearsavailable/').map(res => res.json());
  }


  getAllUsersActivities(id: number, year: number) {
    return this.authHttp.get('/api/activity/user/' + id + '/'+year).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/activity.service.ts